import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import 'node-remove-polyfill';


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {EGAPRO_CONTENT, HANDICAP_CONTENT, SANTE_SECURITE_AU_TRAVAIL_CONTENT, HANDIPSY_CONTENT} from "./codes";

const contents = [HANDICAP_CONTENT, EGAPRO_CONTENT, SANTE_SECURITE_AU_TRAVAIL_CONTENT, HANDIPSY_CONTENT];
const subdomain = document.domain.split('.')[0];
const content = contents.includes(subdomain) ? subdomain : contents[0];
ReactDOM.render(
    <React.StrictMode>
        <App quizContent={content}/>
    </React.StrictMode>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
